export const errorMessageMap = {
  paymentDecline:
    "Your payment has been declined by your card issuer. Please contact your card issuer or use another debit card for this payment.",
  insufficientFunds:
    "Your payment has been declined by your card issuer due to insufficient funds. Please use another debit card to make your payment or contact your card issuer to discuss.",
  exceedCreditLimit:
    "The payment amount you entered exceeds your credit balance. Please check if you have any pending transactions or you might need to reduce the payment amount and try again.",
  cardDoesNotMatchRegionAu:
    "We can’t accept payments from a debit card issued by an international bank. You can pay using your debit card, as long as it has been issued by an Australian bank. Please try again using one of your Australian issued debit cards.",
  cardDoesNotMatchRegionNz:
    "We can’t accept payments from a debit card issued by an international bank. You can pay using your debit card, as long as it has been issued by a NZ bank. Please try again using one of your NZ issued debit cards.",
};
